import React from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// Import required modules
import { Pagination, Autoplay } from 'swiper/modules';
import { useTranslation } from 'react-i18next';

// Import images
import banner1 from '../assets/images/rassenheader1.png';
import banner2 from '../assets/images/rassenheader2.png';
import banner3 from '../assets/images/rassenheader3.png';
import banner4 from '../assets/images/rassenheader4.png';

const BannerSlider = () => {
    const { i18n } = useTranslation();
    const isRtl = i18n.language === 'ar';

    const banners = [
        { id: 1, src: banner1, alt: "Banner 1" },
        { id: 2, src: banner2, alt: "Banner 2" },
        { id: 3, src: banner3, alt: "Banner 3" },
        { id: 4, src: banner4, alt: "Banner 4" },
    ];

    return (
        <section className="w-full relative overflow-hidden bg-gray-100 mt-3 sm:mt-0">
            <Swiper
                key={i18n.language}
                dir={isRtl ? 'rtl' : 'ltr'}
                modules={[Pagination, Autoplay]}
                spaceBetween={0}
                slidesPerView={1}
                pagination={{ clickable: true }}
                autoplay={{ delay: 5000, disableOnInteraction: false }}
                loop={true}
                className="w-full"
            >
                {banners.map((banner) => (
                    <SwiperSlide key={banner.id}>
                        <div className="relative w-full">
                            <img
                                src={banner.src}
                                alt={banner.alt}
                                className="w-full h-auto block"
                            />
                            {/* Overlay for professional touch */}
                            <div className="absolute inset-0 bg-black/5"></div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>

            {/* Custom Styling for Swiper Bullets */}
            <style jsx global>{`
                .swiper-pagination-bullet-active {
                    background: #006C35 !important;
                }
            `}</style>
        </section>
    );
};

export default BannerSlider;
